export default __webpack_public_path__ + "f17b5c6bba7da7d542857915ac4d32e6.svg";